import LookupInput from './LookupInput';

const lookup = {
  key: 'lookup',
  content: {
    use_entire_spreadsheet: true,
    target: ''
  },
  format: ({ key, variable, content }) => {
    if (content.use_entire_spreadsheet) {
      return `${key}.${variable}`;
    }

    return `${key}.${variable}.${content.target}`;
  },
  Input: LookupInput,
  valid: content => {
    if (content.use_entire_spreadsheet) {
      return true;
    }

    return content.target.length > 0;
  }
};

export default lookup;
